import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ngcEmailNotificationType'
})
export class EmailNotificationTypePipe implements PipeTransform {

    readonly EMAIL_NOTIFICATION_TYPES = {
        Provider_Validation: 'Institution Validation',
        Vendor_Validation: 'Vendor Validation',
        System: 'System'
    };

    transform(value: string, args?: any): any {
        if (this.EMAIL_NOTIFICATION_TYPES[value]) {
            return this.EMAIL_NOTIFICATION_TYPES[value];
        } else {
            return value ? value.replace(/[_-]/g, ' ') : '';
        }
    }
}
